import { sizes } from './sizes';

export const spacing = {
  navbarHeight: sizes.navbarHeight, // Used for the new mobile navbar ONLY
  navbarWidth: sizes.navbarWidth, // Used for the side main nav ONLY
  sidebarWidth: sizes.sidebarWidth, // Used for the sidebar subnav ONLY
  sidebarCollapse: sizes.sidebarCollapse, // Used for the collapsed sidebar subnav ONLY
  sidebarPx: '1.25rem',
  sidebarPxSmall: '0.625rem',
};
